export default __webpack_public_path__ + "static/media/cancel.33283cfd.svg";